import axios from './axios'
import { CONTENT_TYPE } from './constant'

export const autocomplete = (params) => {
  const urlParams = new URLSearchParams(params).toString()
  return axios.get(`/buy/google/maps/autocomplete?${urlParams}`)
}

export const checkTaxNumber = (params) =>
  axios.post('/tax/validate', params, {
    headers: {
      'Content-Type': CONTENT_TYPE.FORM_DATA
    }
  })

export const getAddrDetail = ({ placeId, language }) =>
  axios.get(`/buy/google/maps/place/details?place_id=${placeId}&language=${language}`)

export const updateContact = (params) => axios.post('/payment/contact/update', params)

export const getTtrTaxExemptLinkForNewCustomer = (params = {}) =>
  axios.post('/buy/TTRInfo', params, {
    headers: {
      'Content-Type': CONTENT_TYPE.JSON
    }
  })

export const getTtrTaxExemptLinkForExitingCustomer = () => axios.get('/buy/existing_customer_portal')

export const getTtrTaxStatus = () =>
  axios.get('/buy/taxStatus', {
    headers: {
      'Content-Type': CONTENT_TYPE.JSON
    }
  })
